module.exports = __webpack_public_path__ + "img/10.4d38946e.png";